module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_9016.5bc105f3.png";